export default {
  en: {
    /** 会員情報入力 */
    ChangeMembershipInput: {
      top: 'Please read before entering:',
      disc1:
        'For the handling of personal information collected by Shimadzu Corporation , please refer to Handling of Personal Information.',
      formItem: {
        email: 'Change Email Address',
        password: 'Change Password',
        inputOrSelect: 'Input or Select',
        text: 'By registering more detailed information, you will enable us to provide more relevant recommendations and information for you.'
      },
      emailSubscription: {
        title: 'Email subscription',
        desc: 'Shimadzu sends an occasional email newsletter with news of seminars, campaigns etc. Please check the box to receive these updates from us.'
      },
      unregister: 'Unregister from the site',
      productCategoryEquipDescription: ''
    },
    /** 会員情報確認 */
    ChangeMembershipConfirm: {
      top: 'Please confirm the input contents.'
    }
  },
  'zh-hant': {
    /** 会員情報入力 */
    ChangeMembershipInput: {
      top: '請詳閱以下說明：',
      disc1: '有關島津集團個資蒐集管理，請參閱網站個人資料保護方針。',
      formItem: {
        email: '變更電子信箱',
        password: '變更密碼',
        inputOrSelect: '輸入或選擇',
        text: '通過註冊完整資料，我們將提供您更豐富的相關資訊與推薦。'
      },
      emailSubscription: {
        title: '電子郵件訂閱',
        desc: 'Shimadzu 將會不定期發送電子報，其中包含研討會、活動等最新資訊。請勾選此框以接收我們最新情報。'
      },
      unregister: '註銷帳號',
      productCategoryEquipDescription: ''
    },
    /** 会員情報確認 */
    ChangeMembershipConfirm: {
      top: '請確認填寫內容無誤。'
    }
  },
  ja: {
    /** 会員情報入力 */
    ChangeMembershipInput: {
      top: '',
      disc1: '',
      formItem: {
        email: 'メールアドレスを変更する',
        password: 'パスワードを変更する',
        inputOrSelect: '入力または選択',
        text: 'より詳細な情報を登録することで、より適切な推奨事項や情報を提供することができます。'
      },
      productCategoryEquipDescription:
        '以下の製品については装置管理情報をご提供しています。<br />・HPLC・LC-MS<br />・GC・GC-MS<br />・分光分析（UV・FTIR・RF）<br />・元素分析（AA）<br />・TA<br />・TOC<br />・ライフサイエンス試薬<br />'
    },
    /** 会員情報確認 */
    ChangeMembershipConfirm: {
      top: '入力内容をご確認ください'
    }
  },
  es: {
    /** 会員情報入力 */
    ChangeMembershipInput: {
      top: 'Por favor, lea antes de entrar:',
      disc1:
        'Para el manejo de la información personal recopilada por Shimadzu Corporation, consulte Manejo de información personal.',
      formItem: {
        email: 'Cambiar dirección de correo electrónico',
        password: 'Cambiar contraseña',
        inputOrSelect: 'Introducir o seleccionar',
        text: 'Al registrar información más detallada, nos permitirá proporcionarle recomendaciones e información más relevantes.'
      },
      emailSubscription: {
        title: 'Suscripción por correo electrónico',
        desc: 'Shimadzu envía ocasionalmente un boletín electrónico con noticias de seminarios, campañas, etc. Marque la casilla para recibir estas actualizaciones de nosotros.'
      },
      unregister: 'Cancelar el registro del sitio',
      productCategoryEquipDescription: ''
    },
    /** 会員情報確認 */
    ChangeMembershipConfirm: {
      top: 'Please confirm the input contents.'
    }
  },
  'pt-br': {
    /** 会員情報入力 */
    ChangeMembershipInput: {
      top: 'Leia antes de prosseguir:',
      disc1:
        'Para saber como a Shimadzu Corporation trata as informações pessoais coletadas, consulte o Manuseio de Informações Pessoais.',
      formItem: {
        email: 'Alterar o endereço de e-mail',
        password: 'Alterar a senha',
        inputOrSelect: 'Insira ou selecione',
        text: 'Ao registrar informações mais detalhadas, você permitirá que a Shimadzu forneça recomendações e informações mais relevantes para você.'
      },
      emailSubscription: {
        title: 'Assinatura de e-mail',
        desc: 'A Shimadzu envia periodicamente um boletim informativo por e-mail com notícias de seminários, campanhas etc. Por favor, marque a caixa para receber nossas atualizações.'
      },
      unregister: 'Cancelar inscrição no site',
      productCategoryEquipDescription: ''
    },
    /** 会員情報確認 */
    ChangeMembershipConfirm: {
      top: 'Please confirm the input contents.'
    }
  }
}
